<div class="" id="{{ card.id }}" [attr.data-automation-id]="card.automationId">
  <div class="bl-display--flex bl-margin-bottom--16">
    <p class="bl-align-self--center bl-margin--0 bl-margin-top--24 bl-margin-top-sm--0 bl-flex--auto">
      <button
        id="edit-{{ card.id }}"
        type="button"
        [routerLink]="editRouteLink"
        (click)="goToEdit()"
        [fragment]="card.id"
        class="bl-button bl-button-small bl-button-reverse bl-float--right"
      >
        <span class="bl-font-color--primary">
          <span class="bl-font-size--14 cu-icons cu-edit bl-margin-right--4"></span>
          <span>{{ 'applicationReview/edit' | dictionary }}</span>
        </span>
      </button>
    </p>
  </div>
  <ng-container *ngFor="let applicant of requestedDocumentApplicants; let applicantIndex = index">
    <h3 class="bl-font-size--22 bl-font-weight--900 bl-margin-bottom--8"> {{applicant?.name}} </h3>
    <div *ngFor="let requestedDoc of applicant.requestedDocuments; let fieldIndex = index">
      <div class="bl-margin-bottom--16 review-wrap-width bl-display--flex" 
        [id]="'requested-doc-review-' + requestedDoc.id +'-'+ applicantIndex +'-'+ fieldIndex"
        [attr.data-automation-id]="'requested-doc-review-'+ applicantIndex +'-'+ fieldIndex">
        <div class="bl-margin-bottom--4 bl-col-6">{{ requestedDoc?.name }}</div>
        <div *ngIf="requestedDoc.isDocSubmitted" class="bl-font-color--steel bl-col-5">
          {{ 'requestedDocumentReview/submitted' | dictionary }}
        </div>
        <div *ngIf="!requestedDoc.isDocSubmitted" class="bl-font-color--primary bl-col-5">
          {{ 'requestedDocumentReview/notSubmitted' | dictionary }}
        </div>
      </div>
    </div>
  </ng-container>
</div>
